import { render, staticRenderFns } from "./IDCardValid.vue?vue&type=template&id=c875003a&scoped=true&"
import script from "./IDCardValid.vue?vue&type=script&lang=js&"
export * from "./IDCardValid.vue?vue&type=script&lang=js&"
import style0 from "./IDCardValid.vue?vue&type=style&index=0&id=c875003a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c875003a",
  null
  
)

export default component.exports